<template>
    <!--课程列表-->
    <div class="course content">
        <!--<div class="curr_btn">-->
            <!--<Button type="primary" @click="addCourse()">添加课程</Button>-->
        <!--</div>-->
        <div class="curr_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="courseList"></Table>
        </div>
    </div>
</template>
<style scoped>
.course>div {
    padding: 10px 0;
}
</style>
<script>
import http from "../../libs/http.js"
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            loading: false,
            courseList: [],
            columns: [
                // {
                //     title: 'No.',
                //     key: 'seq',
                //     align: 'center',
                //     width: 100,
                // },
                {
                    title: '课程名称',
                    key: 'courseTitle',
                    align: 'center'
                },
                {
                    title: '章节数',
                    align: 'center',
                    key: 'sectionCount',
                    width: 100,
                },
                {
                    title: '课程图',
                    key: 'coverUrl',
                    align: 'center',
                    render: (h, params) => {
                        return params.row.coverUrl ? h('img', {
                            attrs: {
                                src: params.row.coverUrl
                            },
                            style: {
                                height: '70px',
                                marginTop: '5px'
                            },
                        }) : h('span', '暂无图片')
                    }
                },
//                {
//                    title: '状态',
//                    key: 'status',
//                    align: 'center',
//                    width: 100,
//                    render: (h, params) => {
//                        return h('div', [
//                            h('span', {
//                                style: {
//                                    color: params.row.status == 1 ? '#19be6b' : '#ed4014'
//                                },
//                            }, params.row.status == 1 ? '已上架' : '未上架'),
//                        ]);
//                    }
//                },
                {
                    title: '操作',
                    width: 300,
                    key: 'action',
                    render: (h, params) => {
                        return h('div', {
                            style: {
                                height: '70px',
                                paddingTop: '25px'
                            }
                        }, [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                },
                                style: {
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.$router.push({ path: 'section', query: { courseStatus: params.row.status, courseId: params.row.courseId, courseTitle: params.row.courseTitle } })
                                    }
                                }
                            }, '课节列表'),
//                            h('Button', {
//                                props: {
//                                    type: 'primary',
//                                    size: 'small',
//                                    disabled: params.row.status == 1 ? true : false
//                                },
//                                style: {
//                                    marginRight: '10px'
//                                },
//                                on: {
//                                    click: () => {
//                                        this.addCourse(params.row.courseId)
//                                    }
//                                }
//                            }, '编辑课程'),
//                            h('Button', {
//                                props: {
//                                    type: 'error',
//                                    size: 'small',
//                                    disabled: this.getLimit == 1 || this.getLimit == 6 ? false : true
//                                },
//                                on: {
//                                    click: () => {
//                                        this.deleteCourse(params.row.courseId)
//                                    }
//                                }
//                            }, '删除')
                        ]);
                    }
                }
            ],
        }
    },
    created() {
        this.getCourse()
    },
    methods: {
        //获取课程列表
        getCourse() {
            let that = this;
            that.loading = true;
            http.post('/custom/course/list').then(res => {
                that.loading = false;
                if (res) {
                    that.courseList = res
                }
            })
        },
        // 点击添加/编辑课程事件
        addCourse(courseId) {
            if (courseId) {
                this.$router.push({ path: 'editCourse', query: { courseId: courseId } })
            } else {
                this.$router.push({ path: 'addCourse' })
            }
        },
        //点击删除事件
        deleteCourse(courseId) {
            let that = this
            this.$Modal.confirm({
                title: '提示',
                content: '确定删除该课程?',
                onOk: () => {
                    http.post('/custom/course/del', {
                        courseId: courseId
                    }).then(res => {
                        if (res) {
                            that.getCourse()
                            that.$Message.success('删除成功');
                        }
                    })
                }
            });
        },
        // 上,下架
        changeStatus(courseId, status) {
            let that = this
            this.$Modal.confirm({
                title: '提示',
                content: '确定' + (status == 1 ? '上架' : '下架') + '该课程?',
                onOk: () => {
                    http.post('/custom/course/edit', {
                        courseId: courseId,
                        status: status
                    }).then(res => {
                        if (res) {
                            that.$Message.success(status == 1 ? '上架成功' : '下架成功');
                            that.getCourse()
                        }

                    })
                }
            });
        },
    },
    computed: {
        ...mapGetters([
            'getLimit',
        ])
    },
}
</script>
